export const calculateHeight = (rowCount: number): number => {

  if (rowCount > 5) {
    return undefined;
  }

  const rowHeight = 45;
  const extraHeight = 30;

  return rowHeight*rowCount+extraHeight;
};
